const FileUserApiUrls = {
    SUBMIT: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/file/user/submit`,
    GET_TPR_USER: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user/get`,
    GET_TPR_USER_PREFERENCE: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user-preference/get`,
    GET_TPR_USER_DETAILS: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user/detail/get`
  };
  
  export default FileUserApiUrls
  